import React from 'react';
import { Label } from './ui/label';
import { useStore } from '../context/StoreContext';

// "Works at" picker: nothing ticked = every store
export const StaffStorePicker = ({ value = [], onChange, idPrefix = 'staff-store' }) => {
  const { stores } = useStore();
  if (stores.length < 2) return null;
  const toggle = (code) => onChange(value.includes(code) ? value.filter(c => c !== code) : [...value, code]);
  return (
    <div className="space-y-2">
      <Label>Works at</Label>
      <div className="flex flex-wrap gap-2">
        {stores.map(s => (
          <label key={s.code} className={`flex items-center gap-2 px-3 py-1.5 rounded-md border text-sm cursor-pointer ${value.includes(s.code) ? 'bg-slate-900 text-white border-slate-900' : 'bg-white text-slate-700'}`}>
            <input type="checkbox" className="sr-only" checked={value.includes(s.code)} onChange={() => toggle(s.code)} data-testid={`${idPrefix}-${s.code}`} />
            {s.name}
          </label>
        ))}
      </div>
      <p className="text-xs text-slate-500">{value.length ? 'Shown on the quick-select only at the ticked store(s)' : 'No store ticked — shown at every store'}</p>
    </div>
  );
};

export const StaffStoreLabel = ({ stores: codes = [] }) => {
  const { storeName, stores } = useStore();
  if (stores.length < 2) return null;
  return <span className="text-xs text-slate-500">{codes.length ? codes.map(storeName).join(', ') : 'All stores'}</span>;
};
